var _circle, _rect, _rect2, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnsubscribe = function SvgUnsubscribe(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 257,
    viewBox: "0 0 257 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 128.5,
    cy: 128.5,
    r: 128.5,
    fill: "#C5CEFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58.0673,
    y: 83.1539,
    width: 140.538,
    height: 78.6346,
    rx: 10.0385,
    fill: "#90CAF9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71.4519,
    y: 43,
    width: 114.606,
    height: 106.24,
    rx: 10.0385,
    fill: "url(#paint0_linear_519_17959)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.567,
    cy: 102.813,
    r: 5.01923,
    fill: "#455A64"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 154.269,
    cy: 102.813,
    r: 5.01923,
    fill: "#455A64"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.115 127.491C118.995 119.822 131.599 109.087 142.976 127.491",
    stroke: "#455A64",
    strokeWidth: 1.67308,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.005 87.3365C106.168 89.5673 102.404 94.0289 94.0385 94.0289",
    stroke: "#455A64",
    strokeWidth: 1.67308,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.25 87.3365C150.087 89.5673 153.851 94.0289 162.216 94.0289",
    stroke: "#455A64",
    strokeWidth: 1.67308,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M198.606 96.1202L198.606 189.556C198.606 192.708 195.251 194.727 192.465 193.252L148.446 169.932C138.684 164.76 137.045 151.452 145.262 144.066L198.606 96.1202Z",
    fill: "#BBDEFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0673 96.1201L58.0673 190.319C58.0673 193.488 61.4553 195.506 64.2422 193.997L108.522 170.011C118.182 164.779 119.747 151.558 111.577 144.215L58.0673 96.1201Z",
    fill: "#BBDEFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190.227 194.832H64.6002C60.5548 194.832 58.8658 189.66 62.1314 187.273L119.89 145.04C125.63 140.844 133.458 140.969 139.06 145.348L192.803 187.354C195.936 189.803 194.204 194.832 190.227 194.832Z",
    fill: "url(#paint1_linear_519_17959)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.591,
    cy: 210.308,
    rx: 73.6154,
    ry: 6.69231,
    fill: "#DCE2FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_519_17959",
    x1: 117.043,
    y1: 14.1394,
    x2: 127.082,
    y2: 96.5385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_519_17959",
    x1: 127.082,
    y1: 137.947,
    x2: 127.082,
    y2: 194.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AD0FC"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnsubscribe);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "unsubscribe.b5858a254a00b093a6dc9880ede2d519.svg";